import { useContext, useEffect, useRef, useState } from "react";
import api from "../../api";
import { UserContext } from "../../context/UserContext";
import "./online-panel.css";

export default function OnlineUsersPanel() {
  const { user, ready } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const pingTimer = useRef(null);
  const pollTimer = useRef(null);

  // Nur aktiv, wenn eingeloggt
  useEffect(() => {
    if (!ready || !user) return;

    const ping = async () => { try { await api.post("/presence/ping"); } catch {} };
    const fetchOnline = async () => {
      try { const { data } = await api.get("/presence/online"); setList(data); } catch {}
    };

    // Sofort einmal
    ping(); fetchOnline();

    // alle 20s pingen, alle 15s Liste holen
    pingTimer.current = setInterval(ping, 20000);
    pollTimer.current = setInterval(fetchOnline, 15000);

    return () => {
      clearInterval(pingTimer.current); pingTimer.current = null;
      clearInterval(pollTimer.current); pollTimer.current = null;
    };
  }, [ready, user]);

  if (!ready || !user) return null;

  return (
    <>
      {!open && (
        <button
          className="apn-online-toggle"
          aria-expanded={open}
          onClick={() => setOpen(v => !v)}
          title="Online-Benutzer anzeigen"
        >
          Online
          <span className="apn-online-dot" aria-hidden="true" />
          {list.length > 0 && <span className="apn-online-count">{list.length}</span>}
        </button>
      )}

      <aside className={`apn-online-panel ${open ? "open" : ""}`} aria-label="Aktuell online" aria-hidden={!open}>
        <div className="apn-online-head">
          <div>Online ({list.length})</div>
          <button className="apn-online-close" onClick={() => setOpen(false)} aria-label="Schließen">×</button>
        </div>

        <div className="apn-online-body">
          <ul className="apn-online-list">
            {list.map(u => (
              <li key={u.id}>
                <a
                  href={`/u/${u.id}`}
                  className={`apn-badge ${Array.isArray(u.roles) && u.roles.includes("admin") ? "admin": ""}`}
                  style={{textDecoration:'none', color:'inherit', cursor:'pointer'}}
                  target="_blank"
                  rel="noopener"
                  title={`Profil von ${u.username} anzeigen`}
                >
                  {u.displayName ? u.displayName : u.username}
                </a>
                <span className="apn-role">
                  {Array.isArray(u.roles)
                    ? u.roles.map(r => {
                        const roleInfo = {
                          member:   { label: "🧑‍🤝‍🧑", color: '#C0C0C0' },
                          admin:    { label: "🛡️", color: '#2e7d32' },
                          moderator:{ label: "👮", color: '#1976d2' },
                          mentor:   { label: "🎓", color: '#32CD89' },
                          anwärter: { label: "🤝", color: '#FFD700' },
                          owner:    { label: "👑", color: '#8F5DD4' }
                        };
                        return <span key={r} style={{background:roleInfo[r]?.color||'#888', color:'white', borderRadius:8, padding:'2px 6px', marginRight:2, fontSize:12}}>{roleInfo[r]?.label||r}</span>;
                      })
                    : <span>{u.role}</span>
                  }
                </span>
              </li>
            ))}
            {list.length === 0 && <li className="apn-empty">Niemand online</li>}
          </ul>
        </div>
      </aside>
    </>
  );
}
